var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,21a1,1,0,0,1-.71-.29l-4-4a1,1,0,0,1,1.42-1.42L15,18.59l6.29-6.3a1,1,0,0,1,1.42,1.42l-7,7A1,1,0,0,1,15,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,29A13,13,0,1,1,29,16,13,13,0,0,1,16,29ZM16,5A11,11,0,1,0,27,16,11,11,0,0,0,16,5Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "frame"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 32,
    width: 32
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/done_icon.7bf327476b37d515584db5807e982e4e.svg";
export { ForwardRef as ReactComponent };